import React, { useState, useEffect, useRef } from 'react';

interface SeveritySelectorProps {
    severity: string;
    setSeverity: (severity: string) => void;
}

const SeveritySelector: React.FC<SeveritySelectorProps> = ({ severity, setSeverity }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const severityLevels = ['error', 'warning', 'info'];

    const getSeverityIcon = (level: string): string => {
        switch (level.toLowerCase()) {
            case 'error':
                return '🚨';
            case 'warning':
                return '⚠️';
            case 'info':
                return 'ℹ️';
            default:
                return '';
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const capitalizeFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    return (
        <div className="filter-group" ref={dropdownRef}>
            <label>Severity:</label>
            <div className="custom-select-container">
                <div className="custom-select-trigger" onClick={() => setIsOpen(!isOpen)}>
                    <span className="severity-content">
                        <span className="severity-icon">{getSeverityIcon(severity)}</span>
                        <span className="severity-text">{capitalizeFirst(severity)}</span>
                    </span>
                    <span className="dropdown-arrow">▼</span>
                </div>
                {isOpen && (
                    <div className="custom-select-dropdown">
                        {severityLevels.map(level => (
                            <div
                                key={level}
                                className={`custom-option ${severity === level ? 'selected' : ''}`}
                                onClick={() => {
                                    setSeverity(level);
                                    setIsOpen(false);
                                }}
                            >
                                <span>{getSeverityIcon(level)}</span>
                                <span>{level.charAt(0).toUpperCase() + level.slice(1)}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SeveritySelector;
